import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type DetailedIndicatorC1Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export type DetailedIndicatorC1Data = {
	attendanceId: number;
	attendanceDate: string;
	attendanceTypeName?: number;
	attendanceHealthUnitId?: number;
	attendanceHealthUnitName?: string;
	attendanceHealthUnitCnes?: string;
	attendanceHealthTeamId?: number;
	attendanceHealthTeamName?: string;
	attendanceHealthTeamIne?: string;
	isScheduled: boolean;
	citizenId: number;
	citizenName: string;
	cpf?: string;
	cns?: string;
	birthdate?: string;
	area?: string;
	healthUnitId?: number;
	healthUnitName?: string;
	healthUnitCnes?: string;
	healthTeamId?: number;
	healthTeamName?: string;
	healthTeamIne?: string;
};

export async function getDetailedIndicatorC1({
	uf,
	ibgeCode,
	...params
}: DetailedIndicatorC1Params) {
	const response = await esusApi.get<Paginated<DetailedIndicatorC1Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c1/detailed-attendances`,
		params
	);
	return response.data ?? new Paginated<DetailedIndicatorC1Data>();
}
